























import { OWebPageBase, OWebRouteContext } from "oweb";
import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class PHome extends BaseComponent {
	appName = app.getAppName();

	get mainComponent() {
		return app.store.route!.slug;
	}
}
